// extracted by mini-css-extract-plugin
export default {"item":"OrderVNĐ_item__8HxK8"};